import React, { useState, useEffect } from 'react';
import { message, Spin, Tooltip, Switch, Popconfirm, Skeleton, Modal, Image, Table, } from 'components/shared/AntComponent';
import { Button, Form, Select, Input, InputNumber, TimePicker, DatePicker, TextArea, Radio } from 'components/shared/FormComponent';
import { DeleteFilled, DownCircleFilled, DownSquareOutlined, LoadingOutlined, SyncOutlined, ArrowLeftOutlined, MinusSquareOutlined, PlusSquareOutlined } from 'components/shared/AntIcons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getQuestionPaper, getQuestionTemplate } from 'services/store/actions/questionPaperAction';
import { addExam, autoGenerateQuestion, generateAutoQuestion, getDeptQuestions, getExamDetail, sendMailtoAll } from 'services/store/actions/examAction';
import dayjs from 'dayjs';
import { getAllApplicant, getApplicantDetails, getApplicantType } from 'services/store/actions/candidateAction';
import { getAccountDetail, getAccountList } from 'services/store/actions/accountAction';
import { getCourse, getSpecialisation } from 'services/store/actions/masterDataAction';
import DelImg from 'assets/img/del.png';


const NewUpdateExam: React.FC = () => {
    const history = useNavigate();
    const [form] = Form.useForm();
    const location = useLocation();
    const dispatch = useDispatch();
    const { questionpaperData, loading: loadingQuestions, loading11, templateInfo } = useSelector((state: any) => state.questionpaper);
    const { candidateData, loading: loadingCandidates, applicantInfo, loading15, appTypeInfo, loading17, loading18, applicantListInfo } = useSelector((state: any) => state.candidate);
    const { success1, loading1, error1, examDetailInfo, loading4, deptQuesInfo, loading12, loading15: autoLoading, autoQuesInfo, loading16, newAutoQuesInfo,
        loading13, success13, error13, addexamData
    } = useSelector((state: any) => state.exam);
    const { loading21, courseInfo, loading12: specLoading, specialisationInfo } = useSelector((state: any) => state.master);
    const { invAccountInfo, loading3 } = useSelector((state: any) => state.account);
    const [isAutomate, setIsAutomate] = useState(false);
    const [questionCount, setQuestionCount] = useState(0);
    const [isNegativemark, setIsNegativemark] = useState(false);
    const [totalMark, setTotalMark] = useState(0);
    const [accID, setAccID] = useState(0);
    const [subdept, setSubdept] = useState('');
    const [subdeptOptions, setSubdeptOptions] = useState([]);
    const [expandVal, setExpandVal]: any = useState([]);
    // const apiUrl = window.location.href.startsWith('https://kovina-a8h7dcdshdddhmcy.southindia-01.azurewebsites.net') ? "https://kovina-api-gba4f4drejguf6dy.southindia-01.azurewebsites.net/api/"
    //     : window.location.href.startsWith('https://qa.kovina.com') ? "https://qa-api.kovina.com/api/" : "https://dev-api-v1.kovina.com/api/";
    const [questionType, setQuestionType] = useState('1');
    const [fieldType, setFieldType] = useState('core_questions');
    const [openModal, setOpenModal] = useState(false);
    const [isFormReady, setIsFormReady] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [totalMarkA, setTotalMarkA] = useState(0);
    const [forceRenderFlag, setForceRenderFlag] = useState(false);  // Force render
    const [selectedSlots, setSelectedSlots] = useState([]);  // For managing selected slots
    const [selectedCandidates, setSelectedCandidates] = useState(new Set()); // Track selected candidates globally
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrmsg, setShowErrMsg] = useState(false);
    const errormsg = showErrmsg ? error1 : false;
    const [deptOptions, setDeptOptions] = useState([]);
    const [dept, setDept]: any = useState(null);
    const userID = localStorage.getItem('userid');
    const [isPastDate, setIsPastDate] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [autoPapers, setAutoPapers]: any = useState(null);
    const [duration, setDuration] = useState(0);
    const [rowData, setRowData]: any = useState(null);
    const [slotID, setSlotID] = useState(0);
    const [openMailModal, setOpenMailModal] = useState(false);
    const [showSuccessmsg1, setShowSuccessmsg1] = useState(false);
    const successmsg1 = showSuccessmsg1 ? success13 : false;
    const [showErrormsg1, setShowErrormsg1] = useState(false);
    const errormsg1 = showErrormsg1 ? error13 : false;
    const [openDangerModal, setOpenDangerModal] = useState(false);
    const [templateName, setTemplateName] = useState('');
    const [isRetakeExam, setIsRetakeExam] = useState(false);
    const [expandedSlots, setExpandedSlots] = useState(new Set([0]));
    const [slots, setSlots] = useState([{
        slotID: 0,
        slotName: "",
        startTime: "",
        endTime: "",
        capacity: null,
        status: 'active',
        questionPaper: {
            quesPaperID: 0,
            quesPaperName: "",
            noOfQuestions: 100,
            totalMarks: 100,
            quesGenMode: "Auto",
            notes: "",
            easyPercent: 30,
            mediumPercent: 40,
            hardPercent: 30,
            isCombinedTemplate: true,
            status: "Active",
            qpSections: [{
                qpSectionID: 0,
                qpSectionName: "",
                isAssoCondition: "all",
                conditionName: [],
                quesTemplateID: null,
            }]
        }
    }]);

    const MAX_SLOTS = 4;


    const templateOptions = !loading11 && templateInfo?.data?.map((item: any) => {
        return {
            value: item?.quesTemplateID?.toString(),
            label: item?.quesTemplateName
        }
    }) || [];

    const courseOptions = !loading21 && courseInfo?.data?.map((item: any) => ({
        label: item?.courseName,
        value: item?.masCourseID,
        actualID: 0,
    }));
    const specOptions = !specLoading && specialisationInfo?.data?.map((item: any) => ({
        value: item?.specializationId,
        label: item?.specializationName,
        id: item?.specializationId,
        description: item.description,
        actualID: 0
    }));
    const accOptions: any = !loading3 && invAccountInfo?.data?.map((acc: any) => {
        return {
            label: acc?.accountName,
            value: acc.id?.toString(),
        };
    }) || [];



    function getCourseList() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getCourse(id) as any);
    }
    useEffect(() => {
        // if (openModal) {
        getCourseList();
        // }
    }, []);
    const calculateEndTime = (startTime: any, durationMinutes: any) => {
        if (!startTime || !durationMinutes) return '';
        const [hours, minutes] = startTime.split(':').map(Number);
        const totalMinutes = hours * 60 + minutes + durationMinutes;
        const endHours = Math.floor(totalMinutes / 60) % 24;
        const endMinutes = totalMinutes % 60;
        return `${String(endHours).padStart(2, '0')}:${String(endMinutes).padStart(2, '0')}`;
    };
    useEffect(() => {
        if (appTypeInfo?.data) {
            const cleanedCourses = appTypeInfo.data.course
                ?.filter((item: any) => {
                    if (!item || typeof item !== 'string') return false;
                    const trimmed = item.trim();
                    // Remove empty, test values, and pure numbers
                    return (
                        trimmed !== '' &&
                        trimmed.toLowerCase() !== 'test_guest' &&
                        isNaN(Number(trimmed))
                    );
                });

            // Deduplicate case-insensitively
            const seen = new Set();
            const uniqueCourses = cleanedCourses.filter((item: string) => {
                const lower = item.toLowerCase();
                if (seen.has(lower)) return false;
                seen.add(lower);
                return true;
            });

            const deptOptions1 = uniqueCourses.map((item: any) => ({
                label: item,
                value: item,
                key: item
            }));

            setDeptOptions(deptOptions1);
        }
    }, [appTypeInfo?.data]);

    useEffect(() => {
        if (!loading16 && newAutoQuesInfo?.status === "success") {
            setAutoPapers(newAutoQuesInfo)
        } else {
            setAutoPapers(null);
        }
    }, [newAutoQuesInfo, loading16]);

    const addSlot = () => {
        if (slots.length < MAX_SLOTS) {
            const newSlot = {
                slotID: 0,
                slotName: "",
                startTime: "",
                endTime: "",
                capacity: null,
                status: 'active',
                questionPaper: {
                    quesPaperID: 0,
                    quesPaperName: "",
                    noOfQuestions: 100,
                    totalMarks: 100,
                    quesGenMode: "Auto",
                    notes: "",
                    easyPercent: 30,
                    mediumPercent: 40,
                    hardPercent: 30,
                    isCombinedTemplate: true,
                    status: "Active",
                    qpSections: [{
                        qpSectionID: 0,
                        qpSectionName: "",
                        isAssoCondition: "all",
                        conditionName: [],
                        quesTemplateID: null,
                    }]
                }
            };
            setSlots([...slots, newSlot]);
            setExpandedSlots(new Set([...expandedSlots, slots.length]));
        }
    };
    const removeSlot = (index: any) => {
        setSlots(slots.filter((_, i) => i !== index));
        const newExpanded = new Set(expandedSlots);
        newExpanded.delete(index);
        setExpandedSlots(newExpanded);
    };

    const updateSlot = (index: any, field: any, value: any) => {
        const newSlots = [...slots];
        newSlots[index] = { ...newSlots[index], [field]: value };

        if (field === 'startTime' && duration) {
            newSlots[index].endTime = calculateEndTime(value, duration);
        }

        setSlots(newSlots);
    };

    const updateQuestionPaper = (slotIndex: any, field: any, value: any) => {
        const newSlots = [...slots];
        newSlots[slotIndex].questionPaper = {
            ...newSlots[slotIndex].questionPaper,
            [field]: value
        };
        setSlots(newSlots);
    };

    const addSection = (slotIndex: any) => {
        const newSlots = [...slots];
        newSlots[slotIndex].questionPaper.qpSections.push({
            qpSectionID: 0,
            qpSectionName: "",
            isAssoCondition: "all",
            conditionName: [],
            quesTemplateID: null,
        });
        setSlots(newSlots);
    };

    const removeSection = (slotIndex: any, sectionIndex: any) => {
        const newSlots = [...slots];
        newSlots[slotIndex].questionPaper.qpSections =
            newSlots[slotIndex].questionPaper.qpSections.filter((_, i) => i !== sectionIndex);
        setSlots(newSlots);
    };

    const updateSection = (slotIndex: any, sectionIndex: any, field: any, value: any) => {
        const newSlots = [...slots];
        newSlots[slotIndex].questionPaper.qpSections[sectionIndex] = {
            ...newSlots[slotIndex].questionPaper.qpSections[sectionIndex],
            [field]: value
        };

        if (field === 'isAssoCondition' && value === 'all') {
            newSlots[slotIndex].questionPaper.qpSections[sectionIndex].conditionName = [];
        }

        setSlots(newSlots);
    };

    const handleExpand = (id: string) => {
        let myArray = expandVal;
        const valueExists = myArray.includes(id);
        if (!valueExists) {
            myArray = [...myArray, id];
        } else {
            if (myArray.includes(id)) {
                myArray = expandVal.filter((item: any) => item != id);
            }
        }
        setExpandVal(myArray);
    };
    const closeModal = () => {
        setOpenModal(false);
    }


    const submitForm = async () => {
        try {
            const val = await form.validateFields();
            const options = [];
            const slots = val?.slots || [];
            if (slots?.length > 0) {
                for (let i = 0; i < slots?.length; i++) {
                    options.push({
                        ExamSlotId: slots[i]?.slotID || 0,
                        ExamID: 0,
                        ExamSlotName: slots[i]?.slotName || "",
                        ExamStartTime: dayjs(slots[i]?.startTime).format('HH:mm:ss'),
                        ExamEndTime: dayjs(slots[i]?.endTime).format('HH:mm:ss'),
                        ExamDuration: val?.duration?.toString() || "",
                        isAssoCondition: slots[i]?.associateCondition || "",
                        conditionName: slots[i]?.specialization?.toString() || "",
                        TotalCapacity: slots[i]?.capacity,
                        "Status": slots[i]?.status || "active",
                        "AccountId": val?.college ? Number(val?.college) : 0,
                        "TenantId": Number(localStorage.getItem('tenantID')),
                        "QuestionPaper": null
                    })
                }
            }
            const inputJson = {
                "ExamID": location.state?.id !== 0 ? location.state?.id : 0,
                "ExamName": val?.examName || "",
                "ExamDescription": val?.description || "",
                "QuesTemplateID": val?.questionTemplate?.toString() || "",
                "QuesTemplateName": val?.questionTemplate ? templateOptions?.filter((item: any) => val?.questionTemplate?.includes(item.value))
                    ?.map((o: any) => o.label)?.join(",") : "",
                "ExamDuration": val?.duration?.toString() || "",
                "ExamDate": val?.examDate ? dayjs(val.examDate).format('YYYY-MM-DD') : '',
                "TotalMarks": val?.totalMark || 0,
                "NegativeMarks": val?.negativeMark || 0,
                "IsAutoSubmit": true,
                "IsAllowRetake": val?.retakeExam || true,
                "MaxAttempts": val?.maxAttempts ? Number(val?.maxAttempts) : 0,
                "IsShowResultAFExam": val?.showResult || true,
                "AccountName": val?.college ? accOptions?.find((item: any) => item.value === val?.college)?.label : "",
                "AccountId": val?.college ? Number(val?.college) : 0,
                "TenantId": Number(localStorage.getItem('tenantID')),
                "ExamSlots": options || null,
            }
            // const inputJson = {
            //     examid: location?.state?.id || 0,
            //     exam_title: val.examTitle,
            //     associated_papers: val.automateQuestions && location?.state?.id == 0 ? "" : val.automateQuestions && location?.state?.id != 0 ? examDetailInfo?.data?.associated_papers || "" : userID === "6" ? val.questionPapers?.toString() : val.questionPapers?.toString() + "," + val.questionPaperA?.toString() || '',
            //     description: val.description || '',
            //     total_marks: totalMark + totalMarkA || 0,
            //     exam_duration: val.duration || '',
            //     exam_date: val.examDate ? dayjs(val.examDate).format('YYYY-MM-DD') : '',
            //     is_negative_mark: val.isNegativeMark || isNegativemark,
            //     negative_mark: val.negativeMark || null,
            //     slots: options,
            //     is_automate_questions: val.automateQuestions || isAutomate,
            //     associated_accountid: val.account || "",
            //     associated_department: val.department?.toString() || "",
            //     section_1_questions: location?.state?.id != 0 && examDetailInfo?.data?.associated_papers ? "" : autoPapers?.section_1_questions || null,
            //     section_2_questions: location?.state?.id != 0 && examDetailInfo?.data?.associated_papers ? "" : autoPapers?.section_2_questions || null
            //     // associated_candidates: val.associateCandidates?.toString() || '',
            // };
           
            dispatch(addExam(inputJson) as any);
            setShowSuccessmsg(true);
            setShowErrMsg(true);
        }
        catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };

    useEffect(() => {
        if (successmsg && addexamData) {
            if (location?.state?.id === 0) {
                message.success('Exam created successfully');
            } else {
                message.success('Exam updated successfully');
            }
            history('/generate-question', { state: { id: addexamData?.data } });
            setShowSuccessmsg(false);
        }
        if (errormsg) {
            if (errormsg?.data) {
                message?.error(errormsg?.data);
            } else {
                message.error("Exam couldn't be created");
            }
            setShowErrMsg(false);
        }
    }, [successmsg, errormsg]);

    const goToPreviousScreen = () => {
        history('/exam');
    };

    const getDetail = () => {
        const id = location.state?.id + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getExamDetail(id) as any);
    };

    const getSpecialisationDetails = () => {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getSpecialisation(id) as any);
    }

    useEffect(() => {
        if (location?.state?.id !== 0) {
            getDetail();
        }
    }, [location?.state?.id]);
    const disablePastDates = (current: dayjs.Dayjs) => {
        // Disable dates before today
        return current && current < dayjs().startOf('day');
    };

    const handleAutoChange = (e: any) => {
        setIsAutomate(e.target.value);
        setTotalMark(0);
        setQuestionCount(0);
        setAutoPapers(null);
        form.setFieldsValue({ "questionPaperA": "", "questionPapers": null, "automateQuestions": e.target.value });
    }
    const handleRetakeChange = (e: any) => {
        setIsRetakeExam(e.target.value);
        form.setFieldValue("maxAttempts", null);
    }

    const handleDurationChange = (e: any) => {
        setDuration(e);
        if (slots && slots.length > 0) {
            const updatedSlots = slots.map((slot: any) => {
                const startTime = dayjs(slot?.slotStartTime?.format('HH:mm a'), 'HH:mm a');
                if (!startTime?.isValid()) {
                    return slot; // Return the slot as is if the start time is invalid
                }

                const endTime = startTime.add(e, 'minute'); // e is the duration in minutes

                return {
                    ...slot,
                    slotEndTime: endTime, // Update the end time in HH:mm a format
                };
            });

        }
    }


    const loadData1 = () => {
        if (examDetailInfo?.data && location.state.id !== 0) {
            const defaultValue = examDetailInfo?.data?.[0] || null;
            const slots = defaultValue?.examSlots || [];
            form.setFieldsValue({
                examName: defaultValue?.examName || "",
                examDate: defaultValue?.examDate ? dayjs(new Date(defaultValue?.examDate)) : null,
                duration: defaultValue?.examDuration ? Number(defaultValue?.examDuration) : null,
                college: defaultValue?.accountId?.toString() || null,
                totalMark: defaultValue?.totalMarks || null,
                negativeMark: defaultValue?.negativeMarks || 0,
                automateQuestions: true,
                showResult: defaultValue?.isShowResultAFExam || false,
                allowRetake: defaultValue?.isAllowRetake || false,
                maxAttempts: defaultValue?.maxAttempts || null,
                questionTemplate: defaultValue?.quesTemplateID ? defaultValue?.quesTemplateID?.split(',') : null,
                description: defaultValue?.examDescription || "",
                slots: defaultValue?.examSlots?.map((item: any) =>
                ({
                    slotID: item.examSlotId || 0,
                    slotName: item.examSlotName || '',
                    startTime: item.examStartTime ? dayjs(item.examStartTime, 'HH:mm:ss') : null,
                    endTime: item.examEndTime ? dayjs(item.examEndTime, 'HH:mm:ss') : null,
                    associateCondition: item.isAssoCondition || "",
                    status: item.status || 'active',
                    capacity: item.totalCapacity || ''
                }))

            });
            setDuration(defaultValue?.examDuration);
            // const slots = defaultValue?.examSlots?.map((item:any)=>{})||[];

            setIsRetakeExam(defaultValue?.isAllowRetake);
        }

        setIsLoaded(true);
    }
    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (examDetailInfo?.data && location?.state?.id !== 0) {
            loadData1();
            // form.setFieldsValue({ "questionPapers": null, "questionPaperA": "" });
        }
    }, [examDetailInfo?.data]);

    function getAppType(id: any) {
        const inputJson = {
            accountid: id?.toString(),
            qualification: "all",
            course: "all"
        }
        dispatch(getApplicantType(inputJson) as any);
    }
    const handleAccountChange = (e: any) => {
        getAppType(e);
        setAccID(e);
        form.setFieldsValue({ "department": null });
        setDeptOptions([]);
    }


    const getApplicList = (accID: any, dept: string) => {
        const inputJson = {
            "Status": "Active",
            "AccountId": Number(accID) || 0,
            "Department": dept || "",
            "TenantId": Number(localStorage.getItem('tenantID'))
        }
        dispatch(getApplicantDetails(inputJson) as any);
    }

    function getQuestions(course: any) {
        const inputJson = {
            "course": course || "",
            "status": "Active"
        }
        dispatch(getDeptQuestions(inputJson) as any);
    }
    const handleQuestionType = (e: any) => {
        setQuestionType(e.target.value);
        if (e.target.value == '2') {
            const subject = autoPapers?.section_2_questions?.[fieldType]?.map((item: any) => {
                return {
                    value: item.department,
                    label: item.department
                }
            });
            setSubdeptOptions(subject);
            setSubdept(subject[0]?.value);
        }
    }

    function getTemplates() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getQuestionTemplate(id) as any);
    }

    useEffect(() => {
        getTemplates();
    }, []);
    function getAccountInfo() {
        const id = 0 + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getAccountDetail(id) as any);
    }

    useEffect(() => {
        getAccountInfo();
    }, []);

    const options = [
        { label: "Department", value: "dept" },
        { label: "Course", value: "course" },
        { label: "Gender", value: "gender" }
    ];
    const options1 = [
        { label: "All", value: "all" },
        { label: "Department", value: "dept" },
        { label: "Course", value: "course" },
        { label: "Gender", value: "gender" }
    ]
    const handleStartTimeChange = (time: any, index: number) => {
        if (time && duration) {
            const startTime = dayjs(time);
            const endTime = startTime.add(duration, 'minute');

            const currentSlots = form.getFieldValue('slots') || [];
            const updatedSlots = [...currentSlots];
            updatedSlots[index] = {
                ...updatedSlots[index],
                startTime: time,
                endTime: endTime
            };

            form.setFieldsValue({ slots: updatedSlots });
        }
    };
    const loadData = () => {
        if (location?.state?.id == 0) {
            form.setFieldsValue({
                examTitle: "",
                examDate: null,
                description: '',
                totalQuestions: '',
                duration: '',
                questionPapers: null,
                associateCandidates: [],
                negativeMark: null,
                questionPaperA: "",
                "isNegativeMark": false,
                "automateQuestions": true,
                slots: [
                    {
                        slotID: 0,
                        slotName: "",
                        startTime: null,
                        endTime: null,
                        capacity: null,
                        associateCondition: '',
                        specialization: null,
                    }
                ], // Add this initial slot
                department: null,
                account: ""
            });
            setIsAutomate(true);
            setIsNegativemark(false);
            setQuestionCount(0);
            setTotalMark(0);
            setDept(null);
        } else {
            console.log("");
        }
    }
  
    const genderOptions = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" }
    ];
    useEffect(() => { getSpecialisationDetails(); }, []);

    const getSpecializationOptions = (condition: string) => {
        switch (condition) {
            case 'dept':
                return courseOptions || []; // Department specializations
            case 'course':
                return specOptions || []; // Course options (B.E, B.Tech, etc.)
            case 'gender':
                return genderOptions; // Gender options
            case 'all':
                return [];
            default:
                return [];
        }
    };
    const getSpecializationOptions1 = (condition: string) => {
        switch (condition) {
            case 'dept':
                return courseOptions || []; // Department specializations
            case 'course':
                return specOptions || []; // Course options (B.E, B.Tech, etc.)
            case 'gender':
                return genderOptions; // Gender options
            case 'all':
                return conditionOptions1 || [];
            default:
                return [];
        }
    };
    const getSpecializationLabel = (condition: string) => {
        switch (condition) {
            case 'dept':
                return 'Department';
            case 'course':
                return 'Course';
            case 'gender':
                return 'Gender';
            case 'all':
                return 'All selected';
            default:
                return '';
        }
    };

    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" }
    ];
  

    const conditionOptions1 = [
        { value: "aptitude", label: "Aptitude" }
    ];
    // Update sections when slot fields change
    const handleSlotFieldChange = (slotIndex: any, field: any, value: any) => {
        if (field === 'associateCondition' || field === 'specialization') {
            setTimeout(() => {
                updateSectionsForSlot(slotIndex);
            }, 100);
        }
    };
   
const getFilteredTemplateOptions = (currentIndex: number) => {
  const selectedTemplates = form.getFieldValue('questionTemplate') || [];
  if (selectedTemplates.length === 0) {
    return templateOptions;
  }

  // Get the value selected in the current row
  const currentValue = selectedTemplates[currentIndex]?.templateID;
  // Get all selected template IDs from other rows
  const selectedInOtherRows = selectedTemplates
    .map((item: any, index: number) => 
      index !== currentIndex ? item?.templateID : null
    )
    .filter((id: any) => id !== null && id !== undefined);
  const filtered = templateOptions.filter((template: any) => {
    // Show if not selected in other rows OR if it's the current selection
    return !selectedInOtherRows.includes(template.value) || template.value === currentValue;
  });
  return filtered;
};
    // Add this function to get filtered department options for sections
    const getFilteredDepartmentOptions = (slotIndex: any, condition: string) => {
        const slots = form.getFieldValue('slots') || [];
        const slotData = slots[slotIndex];
        const selectedSpecializations = slotData?.specialization || [];

        if (!condition || condition === 'all') {
            return conditionOptions1;
        }

        if (selectedSpecializations.length === 0) {
            return getSpecializationOptions1(condition);
        }

        // Filter options based on what's selected in the slot
        const allOptions = getSpecializationOptions1(condition);
        return allOptions.filter((option: any) =>
            selectedSpecializations.includes(option.value)
        );
    };
    const updateSectionsForSlot = (slotIndex: any) => {
        const currentSlots = form.getFieldValue('slots') || [];
        const slot = currentSlots[slotIndex];

        if (!slot) return;

        const associateCondition = slot.associateCondition;
        const specializations = slot.specialization || [];
        const selectedTemplates = form.getFieldValue('questionTemplate') || [];

        let newSections = [];

        // If nothing is selected in associateCondition, keep default section
        if (!associateCondition) {
            newSections = [{
                qpSectionID: 0,
                qpSectionName: "",
                isAssoCondition: "all",
                conditionName: [],
                quesTemplateID: null,
            }];
        }
        // If specializations are selected, create sections based on them
        else if (specializations && specializations.length > 0) {
            newSections = specializations.map((spec: any, index: any) => {
                // Get the label for the specialization
                let specLabel = spec;
                if (associateCondition === 'dept') {
                    const courseOption = courseOptions?.find((opt: any) => opt.value === spec);
                    specLabel = courseOption?.label || spec;
                } else if (associateCondition === 'course') {
                    const specOption = specOptions?.find((opt: any) => opt.value === spec);
                    specLabel = specOption?.label || spec;
                } else if (associateCondition === 'gender') {
                    const genderOption = genderOptions?.find(opt => opt.value === spec);
                    specLabel = genderOption?.label || spec;
                }

                return {
                    qpSectionID: 0,
                    qpSectionName: ``,
                    isAssoCondition: associateCondition,
                    conditionName: [spec],
                    quesTemplateID: selectedTemplates.length > index ? selectedTemplates[index] : selectedTemplates[0] || null,
                };
            });
        }
        // If associateCondition is selected but no specializations (shouldn't happen due to validation)
        else {
            newSections = [{
                qpSectionID: 0,
                qpSectionName: "All",
                isAssoCondition: associateCondition,
                conditionName: [],
                quesTemplateID: selectedTemplates.length > 0 ? selectedTemplates[0] : null,
            }];
        }

        // Update the qpList sections for this slot
        const updatedSlots = [...currentSlots];
        updatedSlots[slotIndex] = {
            ...updatedSlots[slotIndex],
            qpList: {
                ...updatedSlots[slotIndex].qpList,
                section: newSections
            }
        };

        form.setFieldsValue({ slots: updatedSlots });
    };

    const handleAssociateConditionChange = (value: any, index: any) => {
        const currentSlots = form.getFieldValue('slots') || [];
        const updatedSlots = [...currentSlots];

        // Clear specialization when changing associate condition
        updatedSlots[index] = {
            ...updatedSlots[index],
            associateCondition: value,
            specialization: null
        };

        // Also clear section departments
        if (updatedSlots[index]?.qpList?.section) {
            updatedSlots[index].qpList.section = updatedSlots[index].qpList.section.map((sec: any) => ({
                ...sec,
                department: null
            }));
        }

        form.setFieldsValue({ slots: updatedSlots });
        handleSlotFieldChange(index, 'associateCondition', value);
    };

    const handleQuestionTemplateChange = () => {
        // Update all slot sections when templates change
        const currentSlots = form.getFieldValue('slots') || [];
        currentSlots.forEach((_: any, index: any) => {
            updateSectionsForSlot(index);
        });
    };

    const handleSectionAssoConditionChange = (slotIndex: any, sectionIndex: any, value: any) => {
        const currentSlots = form.getFieldValue('slots') || [];
        const updatedSlots = [...currentSlots];

        // If 'all' is selected, set department to aptitude automatically
        if (value === 'all') {
            const sections = updatedSlots[slotIndex].qpList.section;
            sections[sectionIndex] = {
                ...sections[sectionIndex],
                isAssoCondition: value,
                department: 'aptitude'
            };
            form.setFieldsValue({ slots: updatedSlots });
        }
    };
    // Helper function to get filtered section options
    // const getSectionConditionOptions = (slotIndex: number) => {
    //   const slots = form.getFieldValue('slots') || [];
    //   const slotCondition = slots[slotIndex]?.associateCondition;

    //   if (!slotCondition || slotCondition === 'all') {
    //     return options1; // Show all options if slot is 'all' or not set
    //   }

    //   // Show only 'all' and the selected slot condition
    //   return options1.filter(opt => 
    //     opt.value === 'all' || opt.value === slotCondition
    //   );
    // };
    const getSectionConditionOptions = (slotIndex: number, currentSectionIndex: number) => {
        const slots = form.getFieldValue('slots') || [];
        const slotCondition = slots[slotIndex]?.associateCondition;
        const sections = form.getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];

        if (!slotCondition) {
            return options1;
        }

        // Check if "all" is already selected in another section
        const allSelectedInOtherSection = isAllAlreadySelected(slotIndex, currentSectionIndex);

        // Return only "all" and the matching slot condition
        return options1.filter(opt => {
            // Remove "all" if it's already selected in another section
            if (opt.value === 'all' && allSelectedInOtherSection) {
                return false;
            }
            // Show "all" or the same condition as slot
            return opt.value === 'all' || opt.value === slotCondition;
        });
    };
    // Add this validation function before the return statement
    const validatePercentageTotal = (slotIndex: number) => {
        return {
            validator(_: any, value: any) {
                const qpList = form.getFieldValue(['slots', slotIndex, 'qpList']);
                const easy = qpList?.easy || 0;
                const medium = qpList?.medium || 0;
                const hard = qpList?.hard || 0;
                const total = easy + medium + hard;

                if (total !== 100) {
                    return Promise.reject(new Error(`Total must be 100%. Current total: ${total}%`));
                }
                return Promise.resolve();
            },
        };
    };

    // Add this function to check if "all" is already selected in other sections
    // const isAllAlreadySelected = (slotIndex: number, currentSectionIndex: number) => {
    //     const sections = form.getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
    //     return sections.some((section: any, index: number) => 
    //         index !== currentSectionIndex && section.assoCondition === 'all'
    //     );
    // };
    const isAllAlreadySelected = (slotIndex: number, currentSectionIndex: number) => {
        const sections = form.getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
        return sections.some((section: any, index: number) =>
            index !== currentSectionIndex && section?.assoCondition === 'all'
        );
    };
    // Add this function to get available department options for sections
    const getAvailableDepartmentOptions = (slotIndex: number, sectionIndex: number, condition: string) => {
        if (!condition || condition === 'all') {
            return conditionOptions1;
        }

        const sections = form.getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
        const slots = form.getFieldValue('slots') || [];
        const slotSpecializations = slots[slotIndex]?.specialization || [];

        // Get departments already assigned in OTHER sections
        const assignedDepartments = new Set();
        sections.forEach((sec: any, idx: number) => {
            if (idx !== sectionIndex && sec?.department) {
                assignedDepartments.add(sec.department);
            }
        });

        // Get base options based on condition
        let baseOptions = [];
        if (condition === 'dept') {
            baseOptions = courseOptions || [];
        } else if (condition === 'course') {
            baseOptions = specOptions || [];
        } else if (condition === 'gender') {
            baseOptions = genderOptions;
        }

        // Filter to only show slot specializations
        if (slotSpecializations && slotSpecializations.length > 0) {
            baseOptions = baseOptions.filter((opt: any) =>
                slotSpecializations.includes(opt.value)
            );
        }

        // Remove already assigned departments
        return baseOptions.filter((opt: any) =>
            !assignedDepartments.has(opt.value)
        );
        // if (!condition || condition === 'all') {
        //     return conditionOptions1;
        // }

        // const sections = form.getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
        // const slots = form.getFieldValue('slots') || [];
        // const slotSpecializations = slots[slotIndex]?.specialization || [];

        // // Get all selected departments in other sections
        // const selectedDepartments = sections
        //     .filter((_: any, idx: number) => idx !== sectionIndex)
        //     .map((sec: any) => sec.department)
        //     .flat()
        //     .filter(Boolean);

        // // Get filtered options based on slot specialization
        // const filteredOptions = getFilteredDepartmentOptions(slotIndex, condition);

        // // Remove already selected options
        // return filteredOptions.filter((opt: any) => 
        //     !selectedDepartments.includes(opt.value)
        // );
    };

    // Add this function to check if we can add more sections
    const canAddMoreSections = (slotIndex: number) => {
        const sections = form.getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
        const slots = form.getFieldValue('slots') || [];
        const slotSpecializations = slots[slotIndex]?.specialization || [];

        // If "all" is selected in any section, can't add more sections
        // const hasAllCondition = sections.some((sec: any) => sec?.assoCondition === 'all');
        // if (hasAllCondition) {
        //     return false;
        // }

        // If slot has specializations, can only add sections up to the number of specializations
        if (slotSpecializations && slotSpecializations.length > 0) {
            // Count sections that have the slot's condition (not "all")
            const slots = form.getFieldValue('slots') || [];
            const slotCondition = slots[slotIndex]?.associateCondition;

            const sectionsWithSlotCondition = sections.filter((sec: any) =>
                sec?.assoCondition === slotCondition
            );

            // Can add more if we have fewer sections than specializations
            return sectionsWithSlotCondition.length < slotSpecializations.length;
        }

        // If no specializations selected, can always add sections
        return true;
    };
    const validateSectionsMatchSpecializations = (slotIndex: number) => {
        const sections = form.getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
        const slots = form.getFieldValue('slots') || [];
        const slotSpecializations = slots[slotIndex]?.specialization || [];
        const slotCondition = slots[slotIndex]?.associateCondition;

        // If "all" is selected in any section, validation passes
        const hasAllCondition = sections.some((sec: any) => sec?.assoCondition === 'all');
        if (hasAllCondition) {
            return true;
        }

        // If no specializations, validation passes
        if (!slotSpecializations || slotSpecializations.length === 0) {
            return true;
        }

        // Get all departments assigned in sections with matching condition
        const assignedDepartments = new Set();
        sections.forEach((sec: any) => {
            if (sec?.assoCondition === slotCondition && sec?.department) {
                assignedDepartments.add(sec.department);
            }
        });

        // Check if all specializations are assigned
        return slotSpecializations.every((spec: any) => assignedDepartments.has(spec));
    };
    return (
        <div className="my-3 children-container">
            <div className="px-0 ">
                <div className="row m-0 page-header">
                    <h5 className="my-auto col text-start ps-2 text-secondary fw-bold">{location?.state?.id === 0 ? 'Create Exam' : 'Update Exam'}</h5>
                    <div className="ms-auto col-md-8 text-end my-auto pe-2">
                        <Button type="primary" className="col-auto ms-2 btn-back" onClick={goToPreviousScreen}>
                            Back
                        </Button>
                    </div>
                </div>
            </div>
            <Spin spinning={loading4 || loadingQuestions}>
                <div className="body-content-height mx-0 mt-2 row">
                    <div className="col-md-12 px-2">
                        <Form form={form} layout="vertical" preserve={false} className="bg-white p-2">
                            <div className='row mx-0 '>
                                <div className="px-2 py-3 form-padding">
                                    <div className="d-flex m-0 flex-wrap">
                                        <Form.Item className="col-md-6 px-2" label="Exam Title" name="examName"
                                            normalize={(value) =>
                                                value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                            }
                                            rules={[{ required: true, message: 'This field is required' }]}>
                                            <Input disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Date of Exam" name="examDate" rules={[{ required: true, message: 'This field is required' }]}>
                                            <DatePicker className="w-100" format="DD-MM-YYYY" disabledDate={disablePastDates} disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Duration (In Minutes)" name="duration" rules={[{ required: true, message: 'This field is required' }]}>
                                            <InputNumber className="w-100" maxLength={3} onChange={(e) => handleDurationChange(e)} disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.Item label="Select College" name="college" className="col-md-2 px-2" rules={[{ message: "This field is required", required: true }]}>
                                            <Select options={accOptions} />
                                        </Form.Item>
                                    </div>
                                    <div className="row m-0">
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Total Mark" name="totalMark">
                                            <InputNumber className="w-100" maxLength={3} disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Negative Mark" name="negativeMark">
                                            <InputNumber className="w-100" maxLength={3} disabled={isPastDate} />
                                        </Form.Item>
                                        {/* <Tooltip title={!dept ? "Select specialisation to generate questions" : ""}> */}
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Automate Questions" name="automateQuestions" rules={[{ required: true, message: 'This field is required' }]}>
                                            <Radio.Group className='ms-1' onChange={(e) => handleAutoChange(e)} disabled={isPastDate || isAutomate}>
                                                <Radio value={true} >Yes </Radio>
                                                <Radio value={false} >No</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Show results after submission" name="showResult" rules={[{ required: true, message: 'This field is required' }]}>
                                            <Radio.Group className='ms-1' disabled={isPastDate}>
                                                <Radio value={true} >Yes </Radio>
                                                <Radio value={false} >No</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {/* <Tooltip title={!dept ? "Select specialisation to generate questions" : ""}> */}
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Allow retake exam" name="allowRetake" rules={[{ required: true, message: 'This field is required' }]}>
                                            <Radio.Group className='ms-1' onChange={(e) => handleRetakeChange(e)} disabled={isPastDate}>
                                                <Radio value={true} >Yes </Radio>
                                                <Radio value={false} >No</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {isRetakeExam ?
                                            <Form.Item className="col-md-2 col-lg-2 px-2" label="Max. Attempts" name="maxAttempts" rules={[{ required: true, message: 'This field is required' }]}>
                                                <Input />
                                            </Form.Item> : ""}
                                    </div>
                                    <div className="row m-0">
                                        <Form.Item label="Select Question Paper Template" name="questionTemplate" className="col px-2" rules={[{ message: "This field is required", required: true }]}>
                                            <Select options={templateOptions} mode="multiple" />
                                        </Form.Item>
                                    </div>
                                    <Form.Item className={`col-md-12 px-2 desc-form`} label="Description" name="description"
                                        normalize={(value) =>
                                            value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                        }>
                                        <TextArea rows={2} disabled={isPastDate} />
                                    </Form.Item>
                                </div>
                            </div>
                            <Form.List
                                name="slots"
                                initialValue={[
                                    {
                                        slotID: 0,
                                        slotName: "",
                                        startTime: null,
                                        endTime: null,
                                        capacity: null,
                                        associateCondition: '',
                                        specialization: null,
                                        status: '',
                                        qpList: {
                                            questionID: 0,
                                            paperName: "",
                                            easy: null,
                                            medium: null,
                                            hard: null,
                                            notes: "",
                                            section: [{
                                                sectionID: 0,
                                                sectionName: "",
                                                assoCondition: "",
                                                department: null,
                                                templateID: ""
                                            }]
                                        }
                                    }
                                ]}
                            >
                                {(fields, { add: addSection, remove: removeSection }, index: any) => (
                                    <div className="px-2 pb-3">
                                        <div className='row mx-0 mb-2 justify-content-between page-header'>
                                            <h6 className='col my-auto fw-bold ps-0 text-dark'>Slot Details</h6>
                                            <div className='text-end col-md-8'>
                                                <Tooltip title={!duration ? "Please select duration first" : ""}>
                                                    <Button
                                                        type="primary"
                                                        size="small"
                                                        className='ms-2'
                                                        onClick={() => addSection()}
                                                    // disabled={!canAddSection()} // Disable if any section's total percentage is not 100
                                                    >
                                                        Add Slot
                                                    </Button>
                                                </Tooltip>
                                            </div>

                                        </div>
                                        <Table
                                            rowKey="key"
                                            columns={[
                                                {
                                                    title: 'Slot Name',
                                                    dataIndex: 'slotName',
                                                    width: '10%',
                                                    render: (_: any, record: any, index: any) => (
                                                        <Form.Item
                                                            className="mb-0"
                                                            name={[index, 'slotName']}
                                                            rules={[
                                                                { required: true, message: 'This field is required' },
                                                                ({ getFieldValue }) => ({
                                                                    validator(_, value) {
                                                                        const allSections = getFieldValue('sections') || [];
                                                                        const duplicates = allSections.filter(
                                                                            (item: any) =>
                                                                                item.sectionName !== '' &&
                                                                                item.sectionName?.toLowerCase() === value?.toLowerCase()
                                                                        );
                                                                        if (duplicates.length > 1) {
                                                                            return Promise.reject('Duplicate section name');
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }),
                                                            ]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    ),
                                                },
                                                {
                                                    title: 'Start Time',
                                                    dataIndex: 'startTime',
                                                    width: '10%',
                                                    render: (_: any, record: any, index: any) => {
                                                        return (
                                                            <Form.Item
                                                                className="mb-0"
                                                                name={[index, 'startTime']}
                                                                rules={[{ message: 'This field is required', required: true }]}>
                                                                <TimePicker
                                                                    onChange={(time) => handleStartTimeChange(time, index)}
                                                                    format="hh:mm a"
                                                                    className="w-100"
                                                                    disabled={isPastDate || !duration}
                                                                    placeholder={!duration ? "Select duration first" : "Select time"}
                                                                    disabledTime={() => {
                                                                        if (!slots || slots.length === 0 || index === 0) return {};

                                                                        const prevStart = slots[index - 1]?.startTime;
                                                                        if (!prevStart) return {};

                                                                        const prevHour = dayjs(prevStart).hour();
                                                                        const prevMinute = dayjs(prevStart).minute();
                                                                        const isPM = prevHour >= 12;
                                                                        let prevHour12 = prevHour % 12;
                                                                        if (prevHour12 === 0) prevHour12 = 12;

                                                                        return {
                                                                            disabledHours: () =>
                                                                                Array.from({ length: prevHour12 - 1 }, (_, i) => i + 1),
                                                                            disabledMinutes: (hour) => {
                                                                                if (hour === prevHour12) {
                                                                                    return Array.from({ length: prevMinute + 1 }, (_, i) => i);
                                                                                }
                                                                                return [];
                                                                            },
                                                                        };
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        )
                                                    }
                                                },
                                                {
                                                    title: 'End Time',
                                                    dataIndex: 'endTime',
                                                    width: '10%',
                                                    render: (_: any, record: any, index: any) => {
                                                        return (
                                                            <Form.Item
                                                                className="mb-0"
                                                                name={[index, 'endTime']}
                                                                rules={[{ message: 'This field is required', required: true }]}>
                                                                <TimePicker format="hh:mm a" className="w-100" disabled placeholder='Select start time' />
                                                            </Form.Item>

                                                        )
                                                    }
                                                },
                                                {
                                                    title: 'Capacity',
                                                    dataIndex: 'capacity',
                                                    width: '8%',
                                                    render: (_, record, index) => (
                                                        <Form.Item
                                                            className="mb-0"
                                                            name={[index, 'capacity']}
                                                            rules={[{
                                                                validator: (_, value) =>
                                                                    value ? Promise.resolve() : Promise.reject("This field is required"),
                                                            },]}
                                                        >
                                                            <InputNumber
                                                                className="w-100"
                                                                min={0}
                                                            // disabled={!totalMarksValue}
                                                            // onChange={() => handleSectionMarksChange(index)}
                                                            />
                                                        </Form.Item>
                                                    ),
                                                },
                                                {
                                                    title: 'Associate Condition',
                                                    dataIndex: 'associateCondition',
                                                    width: '10%',
                                                    render: (_: any, record: any, index: any) => {
                                                        return (
                                                            <Form.Item
                                                                className="mb-0"
                                                                name={[index, 'associateCondition']}
                                                                rules={[{ message: 'This field is required', required: true }]}>
                                                                <Select className="w-100" options={options}
                                                                    onChange={(value) => handleAssociateConditionChange(value, index)} />
                                                            </Form.Item>
                                                        )
                                                    }
                                                },
                                                {
                                                    title: 'Department/Course/Gender', // Changed title to be more generic
                                                    dataIndex: 'specialization',
                                                    render: (_: any, record: any, index: any) => {
                                                        return (
                                                            <Form.Item
                                                                noStyle
                                                                shouldUpdate={(prevValues, currentValues) => {
                                                                    const prevCondition = prevValues?.slots?.[index]?.associateCondition;
                                                                    const currCondition = currentValues?.slots?.[index]?.associateCondition;
                                                                    return prevCondition !== currCondition;
                                                                }}
                                                            >
                                                                {({ getFieldValue }) => {
                                                                    const slots = getFieldValue('slots') || [];
                                                                    const condition = slots[index]?.associateCondition;
                                                                    const isAllSelected = condition === 'all';
                                                                    const isGenderSelected = condition === 'gender';

                                                                    // Get dynamic options based on condition
                                                                    const dynamicOptions = getSpecializationOptions(condition);
                                                                    const placeholderText = isAllSelected
                                                                        ? "All selected"
                                                                        : `Select ${getSpecializationLabel(condition)}`;

                                                                    return (
                                                                        <Form.Item
                                                                            className="mb-0"
                                                                            name={[index, 'specialization']}
                                                                            rules={[
                                                                                {
                                                                                    message: 'This field is required',
                                                                                    required: !isAllSelected
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Select
                                                                                className="w-100"
                                                                                options={dynamicOptions}
                                                                                disabled={isAllSelected || !condition}
                                                                                placeholder={placeholderText}
                                                                                mode={"multiple"} // Single select for gender, multiple for others
                                                                                showSearch
                                                                                filterOption={(input: any, option: any) => {
                                                                                    return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                                                }}
                                                                            />
                                                                        </Form.Item>
                                                                    );
                                                                }}
                                                            </Form.Item>
                                                        )
                                                    }
                                                },
                                                {
                                                    title: 'Status',
                                                    dataIndex: 'status',
                                                    // width: '20%',
                                                    render: (_: any, record: any, index: any) => {
                                                        // Get the current associate condition value for this row

                                                        return (
                                                            <Form.Item
                                                                className="mb-0"
                                                                name={[index, 'status']}
                                                                rules={[{ message: 'This field is required', required: true }]}>
                                                                <Select className="w-100" options={statusOptions}
                                                                    disabled={isPastDate} />
                                                            </Form.Item>
                                                        )
                                                    }
                                                },
                                                {
                                                    title: 'Actions',
                                                    dataIndex: 'actions',
                                                    align: 'center',
                                                    width: '5%',
                                                    render: (_, __, subIndex) => (
                                                        <div className="my-auto delete-icon d-flex text-center align-items-center justify-content-center">
                                                            {subIndex == 0 ? <Tooltip title="Atlease one slot should be added"><DeleteFilled className='text-gray del-icon' /></Tooltip> :
                                                                <Popconfirm title="Delete Slot" description="Are you sure to delete this slot?" onConfirm={() => removeSection(subIndex)} okText="Yes" cancelText="No">
                                                                    <DeleteFilled className="text-danger pointer del-icon" />
                                                                </Popconfirm>}
                                                        </div>
                                                    ),
                                                },
                                            ]}
                                            dataSource={fields}
                                            pagination={false}
                                            bordered
                                            size="small"
                                            className="section-table"
                                            expandable={{

                                                expandedRowRender: (record, slotIndex) => (
                                                    <div className="py-2 px-3" style={{ padding: '20px', background: '#f9f9f9', borderBottom: '1px solid #e8e8e8' }}>
                                                        <div style={{
                                                            background: 'white',
                                                            border: '2px dashed #1890ff',
                                                            borderRadius: '6px',
                                                            padding: '16px'
                                                        }}>
                                                            {/* Header */}
                                                            <div style={{
                                                                marginBottom: '16px',
                                                                paddingBottom: '12px',
                                                                borderBottom: '1px solid #e8e8e8',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '8px'
                                                            }}>
                                                                <span style={{
                                                                    background: '#1890ff',
                                                                    color: 'white',
                                                                    padding: '4px 12px',
                                                                    borderRadius: '4px',
                                                                    fontSize: '13px',
                                                                    fontWeight: '600'
                                                                }}>
                                                                    📄 Question Paper Configuration
                                                                </span>
                                                            </div>

                                                            {/* Paper Details */}
                                                            <div className="row m-0 mb-3">
                                                                <div className="col-md-4 px-2">
                                                                    <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600' }}>
                                                                        Paper Name *
                                                                    </label>
                                                                    <Form.Item
                                                                        name={[slotIndex, 'qpList', 'paperName']}
                                                                        rules={[{ required: true, message: 'Paper name is required' }]}
                                                                        className="mb-0"
                                                                    >
                                                                        <Input placeholder="e.g., Final Exam Paper" />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="col-md-2 px-2">
                                                                    <label style={{
                                                                        display: 'block',
                                                                        marginBottom: '6px',
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        color: '#52c41a'
                                                                    }}>
                                                                        Easy (%)
                                                                    </label>
                                                                    <Form.Item
                                                                        name={[slotIndex, 'qpList', 'easy']}
                                                                        rules={[{ required: true, message: 'Required' }, validatePercentageTotal(slotIndex)]}
                                                                        className="mb-0"
                                                                    >
                                                                        <InputNumber
                                                                            style={{ width: '100%', borderColor: '#52c41a' }}
                                                                            min={0}
                                                                            max={100}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="col-md-2 px-2">
                                                                    <label style={{
                                                                        display: 'block',
                                                                        marginBottom: '6px',
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        color: '#faad14'
                                                                    }}>
                                                                        Medium (%)
                                                                    </label>
                                                                    <Form.Item
                                                                        name={[slotIndex, 'qpList', 'medium']}
                                                                        rules={[{ required: true, message: 'Required' }, validatePercentageTotal(slotIndex)]}
                                                                        className="mb-0"
                                                                    >
                                                                        <InputNumber
                                                                            style={{ width: '100%', borderColor: '#faad14' }}
                                                                            min={0}
                                                                            max={100}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="col-md-2 px-2">
                                                                    <label style={{
                                                                        display: 'block',
                                                                        marginBottom: '6px',
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        color: '#ff4d4f'
                                                                    }}>
                                                                        Hard (%)
                                                                    </label>
                                                                    <Form.Item
                                                                        name={[slotIndex, 'qpList', 'hard']}
                                                                        rules={[{ required: true, message: 'Required' }, validatePercentageTotal(slotIndex)]}
                                                                        className="mb-0"
                                                                    >
                                                                        <InputNumber
                                                                            style={{ width: '100%', borderColor: '#ff4d4f' }}
                                                                            min={0}
                                                                            max={100}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                            </div>

                                                            {/* Notes */}
                                                            <div className="row m-0 mb-3">
                                                                <div className="col-md-12 px-2">
                                                                    <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600' }}>
                                                                        Notes
                                                                    </label>
                                                                    <Form.Item
                                                                        name={[slotIndex, 'qpList', 'notes']}
                                                                        className="mb-0"
                                                                    >
                                                                        <TextArea rows={2} placeholder="Additional notes..." />
                                                                    </Form.Item>
                                                                </div>
                                                            </div>

                                                            {/* Sections using Form.List */}
                                                            <div style={{ borderTop: '1px solid #e8e8e8', paddingTop: '16px' }}>
                                                                <Form.List
                                                                    name={[slotIndex, 'qpList', 'section']}
                                                                >
                                                                    {(sectionFields, { add: addSectio, remove: removeSectio }) => (
                                                                        <>
                                                                            <Form.Item
                                                                                noStyle
                                                                                shouldUpdate={(prevValues, currentValues) => {
                                                                                    const prevSections = prevValues?.slots?.[slotIndex]?.qpList?.section;
                                                                                    const currSections = currentValues?.slots?.[slotIndex]?.qpList?.section;
                                                                                    const prevSlotSpec = prevValues?.slots?.[slotIndex]?.specialization;
                                                                                    const currSlotSpec = currentValues?.slots?.[slotIndex]?.specialization;
                                                                                    return JSON.stringify(prevSections) !== JSON.stringify(currSections) ||
                                                                                        JSON.stringify(prevSlotSpec) !== JSON.stringify(currSlotSpec);
                                                                                }}
                                                                            >
                                                                                {({ getFieldValue }) => {
                                                                                    const currentSections = getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
                                                                                    const slots = getFieldValue('slots') || [];
                                                                                    const slotSpecializations = slots[slotIndex]?.specialization || [];
                                                                                    const hasAllInSections = currentSections.some((sec: any) => sec?.assoCondition === 'all');
                                                                                    const canAdd = canAddMoreSections(slotIndex);

                                                                                    let tooltipMessage = "";
                                                                                    if (!canAdd) {
                                                                                        //  if (slotSpecializations.length > 0) {
                                                                                        //     tooltipMessage = `Maximum sections reached`;
                                                                                        // } else {
                                                                                        tooltipMessage = "Maximum sections reached";
                                                                                        // }
                                                                                    }

                                                                                    return (
                                                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                            <h6 className="m-0 fw-bold">📚 Sections</h6>
                                                                                            <Tooltip title={tooltipMessage}>
                                                                                                <Button
                                                                                                    type="dashed"
                                                                                                    size="small"
                                                                                                    onClick={() => {
                                                                                                        addSectio({
                                                                                                            sectionID: 0,
                                                                                                            sectionName: "",
                                                                                                            assoCondition: "",
                                                                                                            department: null,
                                                                                                            templateID: null
                                                                                                        });
                                                                                                    }}
                                                                                                    icon={<PlusSquareOutlined />}
                                                                                                    disabled={!canAdd}
                                                                                                >
                                                                                                    Add Section ({currentSections.length}/{slotSpecializations.length + 1 || '∞'})
                                                                                                </Button>
                                                                                            </Tooltip>
                                                                                        </div>
                                                                                    );
                                                                                }}
                                                                            </Form.Item>
                                                                            {/* <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                <h6 className="m-0 fw-bold">📚 Sections</h6>
                                                                                <Button
                                                                                    type="dashed"
                                                                                    size="small"
                                                                                    onClick={() => addSectio()}
                                                                                    icon={<PlusSquareOutlined />}
                                                                                >
                                                                                    Add Section
                                                                                </Button>
                                                                            </div> */}

                                                                            {/* Sections Table */}
                                                                            <Table
                                                                                dataSource={sectionFields}
                                                                                rowKey="key"
                                                                                pagination={false}
                                                                                size="small"
                                                                                bordered
                                                                                columns={[
                                                                                    {
                                                                                        title: 'Section Name',
                                                                                        dataIndex: 'sectionName',
                                                                                        width: '20%',
                                                                                        render: (_, __, sectionIndex) => (
                                                                                            <Form.Item
                                                                                                name={[sectionIndex, 'sectionName']}
                                                                                                rules={[{ required: true, message: 'Required' }]}
                                                                                                className="mb-0"
                                                                                            >
                                                                                                <Input size="small" placeholder="Section A" />
                                                                                            </Form.Item>
                                                                                        )
                                                                                    },
                                                                                    {
                                                                                        title: 'Associate Condition',
                                                                                        dataIndex: 'assoCondition',
                                                                                        width: '15%',
                                                                                        render: (_, __, sectionIndex) => (
                                                                                            // <Form.Item
                                                                                            //     name={[sectionIndex, 'assoCondition']}
                                                                                            //     rules={[{ required: true, message: 'Required' }]}
                                                                                            //     className="mb-0"
                                                                                            //     initialValue="all"
                                                                                            // >
                                                                                            //     <Select
                                                                                            //         size="small"
                                                                                            //         style={{ width: '100%' }}
                                                                                            //         options={options1}
                                                                                            //         onChange={(value) => {
                                                                                            //             if (value === 'all') {
                                                                                            //                 const currentSections = form.getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
                                                                                            //                 currentSections[sectionIndex] = {
                                                                                            //                     ...currentSections[sectionIndex],
                                                                                            //                     department: null
                                                                                            //                 };
                                                                                            //                 form.setFieldsValue({
                                                                                            //                     slots: form.getFieldValue('slots')
                                                                                            //                 });
                                                                                            //             }
                                                                                            //         }}
                                                                                            //     />
                                                                                            // </Form.Item>
                                                                                            // <Form.Item
                                                                                            //     noStyle
                                                                                            //     shouldUpdate={(prevValues, currentValues) => {
                                                                                            //         const prevSlotCondition = prevValues?.slots?.[slotIndex]?.associateCondition;
                                                                                            //         const currSlotCondition = currentValues?.slots?.[slotIndex]?.associateCondition;
                                                                                            //         return prevSlotCondition !== currSlotCondition;
                                                                                            //     }}
                                                                                            // >
                                                                                            //     {({ getFieldValue }) => (
                                                                                            //         <Form.Item
                                                                                            //             name={[sectionIndex, 'assoCondition']}
                                                                                            //             rules={[{ required: true, message: 'Required' }]}
                                                                                            //             className="mb-0"

                                                                                            //         >
                                                                                            //             <Select
                                                                                            //                 size="small"
                                                                                            //                 style={{ width: '100%' }}
                                                                                            //                 options={getSectionConditionOptions(slotIndex,sectionIndex)}
                                                                                            //                 onChange={(value) => {
                                                                                            //                     if (value === 'all') {
                                                                                            //                         const currentSections = form.getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
                                                                                            //                         currentSections[sectionIndex] = {
                                                                                            //                             ...currentSections[sectionIndex],
                                                                                            //                             department: null
                                                                                            //                         };
                                                                                            //                         form.setFieldsValue({
                                                                                            //                             slots: form.getFieldValue('slots')
                                                                                            //                         });
                                                                                            //                     }
                                                                                            //                 }}
                                                                                            //             />
                                                                                            //         </Form.Item>
                                                                                            //     )}
                                                                                            // </Form.Item>
                                                                                            <Form.Item
                                                                                                noStyle
                                                                                                shouldUpdate={(prevValues, currentValues) => {
                                                                                                    const prevSlotCondition = prevValues?.slots?.[slotIndex]?.associateCondition;
                                                                                                    const currSlotCondition = currentValues?.slots?.[slotIndex]?.associateCondition;
                                                                                                    const prevSections = prevValues?.slots?.[slotIndex]?.qpList?.section;
                                                                                                    const currSections = currentValues?.slots?.[slotIndex]?.qpList?.section;
                                                                                                    return prevSlotCondition !== currSlotCondition ||
                                                                                                        JSON.stringify(prevSections) !== JSON.stringify(currSections);
                                                                                                }}
                                                                                            >
                                                                                                {({ getFieldValue }) => {
                                                                                                    const availableOptions = getSectionConditionOptions(slotIndex, sectionIndex);
                                                                                                    const currentSection = getFieldValue(['slots', slotIndex, 'qpList', 'section', sectionIndex]);

                                                                                                    return (
                                                                                                        <Form.Item
                                                                                                            name={[sectionIndex, 'assoCondition']}
                                                                                                            rules={[{ required: true, message: 'Required' }]}
                                                                                                            className="mb-0"
                                                                                                        >
                                                                                                            <Select
                                                                                                                size="small"
                                                                                                                style={{ width: '100%' }}
                                                                                                                options={availableOptions}
                                                                                                                onChange={(value) => {
                                                                                                                    const currentSections = getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
                                                                                                                    currentSections[sectionIndex] = {
                                                                                                                        ...currentSections[sectionIndex],
                                                                                                                        assoCondition: value,
                                                                                                                        department: null
                                                                                                                    };
                                                                                                                    form.setFieldsValue({
                                                                                                                        slots: getFieldValue('slots')
                                                                                                                    });

                                                                                                                    setTimeout(() => {
                                                                                                                        form.validateFields();
                                                                                                                    }, 0);
                                                                                                                }}
                                                                                                            />
                                                                                                        </Form.Item>
                                                                                                    );
                                                                                                }}
                                                                                            </Form.Item>
                                                                                        )
                                                                                    },
                                                                                    {
                                                                                        title: 'Department/Course/Gender',
                                                                                        dataIndex: 'department',
                                                                                        width: '25%',
                                                                                        render: (_, __, sectionIndex) => (

                                                                                            // <Form.Item
                                                                                            //     noStyle
                                                                                            //     shouldUpdate={(prevValues, currentValues) => {
                                                                                            //         const prevCondition = prevValues?.slots?.[slotIndex]?.qpList?.section?.[sectionIndex]?.assoCondition;
                                                                                            //         const currCondition = currentValues?.slots?.[slotIndex]?.qpList?.section?.[sectionIndex]?.assoCondition;
                                                                                            //         const prevSlotSpec = prevValues?.slots?.[slotIndex]?.specialization;
                                                                                            //         const currSlotSpec = currentValues?.slots?.[slotIndex]?.specialization;
                                                                                            //         return prevCondition !== currCondition ||
                                                                                            //             JSON.stringify(prevSlotSpec) !== JSON.stringify(currSlotSpec);
                                                                                            //     }}
                                                                                            // >
                                                                                            //     {({ getFieldValue }) => {
                                                                                            //         const sections = getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
                                                                                            //         const condition = sections[sectionIndex]?.assoCondition;
                                                                                            //         const isAllSelected = condition === 'all';

                                                                                            //         return (
                                                                                            //             <Form.Item
                                                                                            //                 name={[sectionIndex, 'department']}
                                                                                            //                 rules={[{
                                                                                            //                     required: !isAllSelected,
                                                                                            //                     message: 'Required'
                                                                                            //                 }]}
                                                                                            //                 className="mb-0"
                                                                                            //             >
                                                                                            //                 <Select
                                                                                            //                     size="small"
                                                                                            //                     style={{ width: '100%' }}
                                                                                            //                     options={getFilteredDepartmentOptions(slotIndex, condition)}
                                                                                            //                     placeholder="Select"
                                                                                            //                     showSearch
                                                                                            //                     filterOption={(input: any, option: any) => {
                                                                                            //                         return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                                                            //                     }}
                                                                                            //                 />
                                                                                            //             </Form.Item>
                                                                                            //         );
                                                                                            //     }}
                                                                                            // </Form.Item>
                                                                                            <Form.Item
                                                                                                noStyle
                                                                                                shouldUpdate={(prevValues, currentValues) => {
                                                                                                    const prevCondition = prevValues?.slots?.[slotIndex]?.qpList?.section?.[sectionIndex]?.assoCondition;
                                                                                                    const currCondition = currentValues?.slots?.[slotIndex]?.qpList?.section?.[sectionIndex]?.assoCondition;
                                                                                                    const prevSlotSpec = prevValues?.slots?.[slotIndex]?.specialization;
                                                                                                    const currSlotSpec = currentValues?.slots?.[slotIndex]?.specialization;
                                                                                                    const prevSections = prevValues?.slots?.[slotIndex]?.qpList?.section;
                                                                                                    const currSections = currentValues?.slots?.[slotIndex]?.qpList?.section;
                                                                                                    return prevCondition !== currCondition ||
                                                                                                        JSON.stringify(prevSlotSpec) !== JSON.stringify(currSlotSpec) ||
                                                                                                        JSON.stringify(prevSections) !== JSON.stringify(currSections);
                                                                                                }}
                                                                                            >
                                                                                                {({ getFieldValue }) => {
                                                                                                    const sections = getFieldValue(['slots', slotIndex, 'qpList', 'section']) || [];
                                                                                                    const condition = sections[sectionIndex]?.assoCondition;
                                                                                                    const isAllSelected = condition === 'all';
                                                                                                    const availableOptions = getAvailableDepartmentOptions(slotIndex, sectionIndex, condition);

                                                                                                    return (
                                                                                                        <Form.Item
                                                                                                            name={[sectionIndex, 'department']}
                                                                                                            rules={[{
                                                                                                                required: true,
                                                                                                                message: 'Required'
                                                                                                            }]}
                                                                                                            className="mb-0"
                                                                                                        >
                                                                                                            <Select
                                                                                                                size="small"
                                                                                                                style={{ width: '100%' }}
                                                                                                                options={availableOptions}
                                                                                                                placeholder={isAllSelected ? "All selected" : "Select"}
                                                                                                                // disabled={isAllSelected}
                                                                                                                showSearch
                                                                                                                filterOption={(input: any, option: any) => {
                                                                                                                    return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                                                                                }}
                                                                                                                onChange={() => {
                                                                                                                    setTimeout(() => {
                                                                                                                        form.validateFields();
                                                                                                                    }, 0);
                                                                                                                }}
                                                                                                            />
                                                                                                        </Form.Item>
                                                                                                    );
                                                                                                }}
                                                                                            </Form.Item>

                                                                                        )
                                                                                    },
                                                                                    {
                                                                                        title: 'Question Template',
                                                                                        dataIndex: 'templateID',
                                                                                        width: '30%',
                                                                                        render: (_, __, sectionIndex) => (
                                                                                            <Form.Item
                                                                                                noStyle
                                                                                                shouldUpdate={(prevValues, currentValues) => {
                                                                                                    const prevTemplates = prevValues?.questionTemplate;
                                                                                                    const currTemplates = currentValues?.questionTemplate;
                                                                                                    return JSON.stringify(prevTemplates) !== JSON.stringify(currTemplates);
                                                                                                }}
                                                                                            >
                                                                                                {() => (
                                                                                                    <Form.Item
                                                                                                        name={[sectionIndex, 'templateID']}
                                                                                                        rules={[{ required: true, message: 'Required' }]}
                                                                                                        className="mb-0"
                                                                                                    >
                                                                                                        <Select
                                                                                                            size="small"
                                                                                                            style={{ width: '100%' }}
                                                                                                            options={getFilteredTemplateOptions(sectionIndex)}
                                                                                                            placeholder="Select template"
                                                                                                            showSearch
                                                                                                            filterOption={(input: any, option: any) => {
                                                                                                                return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                                                                            }}
                                                                                                        />
                                                                                                    </Form.Item>
                                                                                                )}
                                                                                            </Form.Item>

                                                                                        )
                                                                                    },
                                                                                    {
                                                                                        title: 'Actions',
                                                                                        dataIndex: 'actions',
                                                                                        align: 'center',
                                                                                        width: '10%',
                                                                                        render: (_, __, sectionIndex) => (
                                                                                            <div className="my-auto delete-icon d-flex text-center align-items-center justify-content-center">
                                                                                                {sectionIndex === 0 ? (
                                                                                                    <Tooltip title="At least one section required">
                                                                                                        <DeleteFilled className='text-gray del-icon' />
                                                                                                    </Tooltip>
                                                                                                ) : (
                                                                                                    <Popconfirm
                                                                                                        title="Delete Section"
                                                                                                        description="Are you sure you want to delete this section?"
                                                                                                        onConfirm={() => removeSectio(sectionIndex)}
                                                                                                        okText="Yes"
                                                                                                        cancelText="No"
                                                                                                    >
                                                                                                        <DeleteFilled className="text-danger pointer del-icon" />
                                                                                                    </Popconfirm>
                                                                                                )}
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                ]}
                                                                            />
                                                                        </>
                                                                    )}
                                                                </Form.List>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ),
                                                rowExpandable: () => true, // all rows are expandable
                                                expandIcon: ({ expanded, onExpand, record }) => {
                                                    const rowIndex = fields.findIndex((f) => f.key === record.key); // Get correct index
                                                    return (
                                                        <div className="d-flex align-items-center">
                                                            {/* Default Expand Icon */}
                                                            {/* {!totalMarksValue ?
                                                                <Tooltip title="Total Mark field should be filled to proceed further">
                                                                    <span
                                                                        className="me-2"
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        <PlusSquareOutlined />
                                                                    </span>
                                                                </Tooltip> : */}
                                                            <span
                                                                onClick={(e) => onExpand(record, e)}
                                                                className="me-2"
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {expanded ? <MinusSquareOutlined /> : <PlusSquareOutlined />}
                                                            </span>
                                                            {rowIndex == 0 ? <Tooltip title="Atleast one section should be added"><DeleteFilled className='text-gray del-icon' /></Tooltip> :
                                                                < Popconfirm
                                                                    title="Delete Section"
                                                                    description="Are you sure you want to delete this section?"
                                                                    onConfirm={() => removeSection(rowIndex)}
                                                                    okText="Yes"
                                                                    cancelText="No"
                                                                >
                                                                    <DeleteFilled className="text-danger pointer" />
                                                                </Popconfirm>}
                                                        </div>
                                                    );
                                                },
                                            }}
                                        />
                                    </div>)}
                            </Form.List>
                        </Form>
                    </div>

                </div>
                {isPastDate ? "" :
                    <div className="row mx-0 mt-3 ps-3 pe-3 mb-3 page-footer-btns">
                        <Button type="default" className="col-auto ms-auto bg-secondary text-white rounded-0 me-2" onClick={goToPreviousScreen}>
                            Cancel
                        </Button>
                        <Button type="primary" className="col-auto me-0" disabled={showAdd || loading16} onClick={submitForm} loading={loading1}>
                            Save
                        </Button>
                    </div>
                }
            </Spin>

        </div>
    );
};

export default NewUpdateExam;
